/* global __VERSION__ */
import packageModule from 'client/package.json';

const { version: packageVersion } = packageModule ?? {};

function getVersion() {
  // __VERSION__ is set in client by vite upon build
  // If not present, we are on server.
  if (typeof __VERSION__ === 'undefined') {
    return packageVersion;
  }
  return __VERSION__;
}

export default {
  appath: '',
  version: getVersion(),
};
